import React, { FC, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import Countdown, { zeroPad } from 'react-countdown';
import { RootState } from 'src/store';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { buttonsReset } from 'src/store/modules/buttons';
import { customlogReset } from 'src/store/modules/customlog';
import { editTextReset } from 'src/store/modules/editText';
import { editCurrentIndex, imageReset } from 'src/store/modules/imageUpload';
import { pagesReset } from 'src/store/modules/pages';

import setInitValue from 'src/utils/setInitValue';
import { changeEnter } from 'src/utils/changeEnter';
import { initTrackingValues } from '../TemplateTracking/SlideFullImageTracking';
import { editUserCompany } from 'src/store/modules/client';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';

// const TEXT_2_JUSTIFY = {
//   left: 'start',
//   center: 'center',
//   right: 'end'
// };

const initViewValues = {
  currentIndex: 0,
  bg: 'color',
  bgImage: {
    background: '',
    multi_image: [
      'https://image.inappmessage.com/sample/defaultGRAYLONGIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultGRAYLONGIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultGRAYLONGIMAGE.webp'
    ]
  },
  deeplink: {
    multi_image: [
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/'
    ]
  },
  bgColor: { background: '#ffffff' },
  radius: { background: 16, multi_image: 16, multi_button: 0 },

  text: {
    multi_title: [
      'A cozy daily outerwear thats perfect for the A cozy daily outerwear thats perfect for the',
      'A template package for smart e-commerce',
      'Add an image or background image that contains text an image or background image that contains text'
    ],
    multi_sub_title: [
      'The Daily Outer Special Exhibition, which will add your health and warm warmth to the season when you are worried about a cold',
      'Take a look at the iam template made just for e-commerce!',
      'Add an image or background image that contains text Add an image or background image that contains text'
    ]
  },
  fontSize: { multi_title: 1.5, multi_sub_title: 0.75 },
  fontWeight: { multi_title: 700, multi_sub_title: 400 },
  color: { multi_title: '#000000', multi_sub_title: '#828282' },
  fontFamily: { multi_title: 'Montserrat', multi_sub_title: 'Montserrat' },
  textAlign: { multi_title: 'left', multi_sub_title: 'left' },

  btnText: {
    multi_button: ['SHOW UP 1', 'SHOW UP 2', 'SHOW UP 3'],
    sub_button: 'close'
  },

  btnFontSize: { multi_button: 1, sub_button: 0.875 },
  btnFontWeight: { multi_button: 600, sub_button: 400 },
  btnColor: { multi_button: '#ffffff', sub_button: '#828282' },
  btnBgColorR: { multi_button: 0, sub_button: 0 },
  btnBgColorG: { multi_button: 0, sub_button: 0 },
  btnBgColorB: { multi_button: 0, sub_button: 0 },
  btnBgColorA: { multi_button: 1, sub_button: 0 },
  btnFontFamily: { multi_button: 'Montserrat', sub_button: 'Montserrat' }
};

const SlideFullImage: FC = () => {
  const dispatch = useDispatch();
  const sliderRef = useRef<any>(null);
  const contentsSliderRef = useRef<any>(null);

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);
  let templateWidth = useSelector((state: any) => state.template.templateWidth);
  let templateHeight = useSelector(
    (state: any) => state.template.templateHeight
  );
  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let bg = useSelector((state: RootState) => state.imageUpload.bg);
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiSubTitleFontURL = getFontURL(fontFamily?.multi_sub_title);
  const multiButtonFontURL = getFontURL(btnFontFamily?.multi_button);
  const subButtonFontURL = getFontURL(btnFontFamily?.sub_button);
  // const multiTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_title}`;
  // const multiSubTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_sub_title}`;
  // const multiButtonFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_button}`;
  // const subButtonFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.sub_button}`;
  const blackImageUrl = 'https://i.ibb.co/ZX7zDn1/Frame-101.png';
  const plusImageUrl = 'https://i.ibb.co/qMpSJ4w/Group-20.png';
  const style = `
  @font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleFontURL});
  }
  @font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleFontURL});
  }
  @font-face {
    font-family: 'multiButton';
    src: url(${multiButtonFontURL});
  }
  @font-face {
    font-family: 'subButton';
    src: url(${subButtonFontURL});
  }

    a {
      color: #000000;
      text-decoration: none;
      cursor: pointer;
    }

    .root_view {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    ${
      bg === 'image'
        ? `background-image: url(${bgImage?.background});`
        : `background: ${bgColor?.background};`
    };

    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    }

    .close_btn {
      height: 20px

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      display: flex;
      align-items: center;
      font-family: ${btnFontFamily?.multi_button};
      font-size: 16px;
            
      letter-spacing: 0.0225rem;
      margin-top: 16px;
    }

    .center_wrapper {
      width: 100%;

      display: flex;
      flex-direction: column;
      gap: 20px;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }
    .slick-track {
      display: flex;
      align-items: center;        
      
    }
    .slick_wrapper .slick-track {
      gap: 20px;
    }
    
    .slider_image_box {
      width: 250px;
      height: 333px;
      outline: none;
      transition: all ease 0.3s 0s;      
    }

    .slider_image_box img,
    .slider_image_act_box img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: ${radius?.multi_image}px;
      outline: none;
    } 

    .plus_btn button {
      width: 1.5rem;
      height: 1.5rem;
      
      background-image: url(${plusImageUrl});
      background-repeat: no-repeat;
      background-size: 1.5rem;
      background-position: center;

      font-size: 0;
      border: none;
      border-radius: 50%;
      background-color: transparent;
    }

    .contents_wrapper,
    .contents_wrapper .slick-slider,
    .contents_wrapper .slick-list,
    .contents_wrapper .slick-track div,
    .contents_wrapper .slick-track img {
      background: transparent;
    }
    .contents_wrapper {
      width: 100%;
      height: 140px;
      padding: 0 10%;
    }

    .contents_box .title {
      width: 100%;
      height: 80px;
      display: flex;
      align-items: center;
    }
    .title .title_inner {
      width: 100%;
      height: auto;
      max-height: 52px;
      line-height: 110%;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.multi_title};
      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily?.multi_title
          : 'multiTitle'
      };
    }
    .contents_box .sub_title {
      width: 100%;
      max-height: 56px;
      display: flex;
      align-items: center;
    }
    .contents_box .sub_title .sub_title_inner {
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;

      text-align: ${textAlign?.multi_sub_title};
      color: ${color?.multi_sub_title};
      font-size: ${fontSize?.multi_sub_title}rem;
      font-weight: ${fontWeight?.multi_sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_sub_title
        )
          ? fontFamily?.multi_sub_title
          : 'multiSubTitle'
      };
    }

    .bottom_wrapper {
      width: 100%;
      padding: 0 10%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .bottom_wrapper button {
      width: 100%;
      height: 48px;
      border: 0;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.multi_button}rem;
      font-weight: ${btnFontWeight?.multi_button};
      color: ${btnColor?.multi_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_button
        )
          ? btnFontFamily?.multi_button
          : 'multiButton'
      };
      border-radius: ${radius?.multi_button}px;
      background-color:rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
    }

    /*
    ${
      templateHeight < 640
        ? `
        .close_btn {
          top: 6%;
        }
        .center_wrapper {
          gap: 0.5rem;
        }

        .slick_wrapper,
        .slick_wrapper .slick-slider,
        .slick_wrapper .slick-list {
          height: 20rem;
        }
        .slider_image_box {
          max-width: calc(12rem * 0.8);
          height: calc(20rem * 0.8);
          // margin-top: 1.8rem;
        }
        .slider_image_box {
          max-width: 12rem;
          height: 20rem;
          outline: none;
        }

        .contents_box .title {
          height: 4rem;
          font-size: ${fontSize?.multi_title - 0.25}rem;
        } 
        .contents_box .sub_title {
          height: 3rem;
        }      

        .bottom_wrapper button {
          height: 2rem;
          font-size: ${btnFontSize?.multi_button - 0.125}rem;
        }
        `
        : ``
    }
    
    ${
      templateWidth > 767
        ? `
          .close_btn {
            height: 2rem;
            top: 10%;
            right: 25%;
          }

          .slick_wrapper,
          .slick_wrapper .slick-slider,
          .slick_wrapper .slick-list {
            height: 38rem;
          }
          .slick_wrapper .slick-list {
            padding: 0 -1rem;
          }
          .slick_wrapper .slick-slide {
            padding: 0 1rem;
          }
          .slider_image_box {
            max-width: calc(22.8125rem * 0.8);
            height: calc(38rem * 0.8);
            // margin-top: 3.5rem;
          }
          .slider_image_box {
            max-width: 22.8125rem;
            height: 38rem;
            outline: none;
          }

          .contents_box .title {
            height: 6rem;
            font-size: ${fontSize?.multi_title + 0.25}rem;
          } 
          .title .title_inner {
            max-height: 4rem;
          }
          .contents_box .sub_title {
            height: 4rem;
            font-size: ${fontSize?.multi_sub_title + 0.25}rem;
          }      

          .contents_wrapper,
          .bottom_wrapper {
            padding: 0 25%;
          }
          .bottom_wrapper button {
            height: 4rem;
            font-size: ${btnFontSize?.multi_button + 0.5}rem;
          }
        `
        : ``
    }
    */  
  `;

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());

      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());

      dispatch(customlogReset());
      dispatch(trackingReset());
    };
  }, []);

  useEffect(() => {
    sliderRef.current.slickGoTo(currentIndex);
    contentsSliderRef.current.slickGoTo(currentIndex);
  }, [currentIndex]);

  const settings = {
    arrows: false,
    dots: false,
    infinite: false,

    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 0,
    letiableWidth: true,
    speed: 300,
    touchThreshold: 300
  };

  const contentsSettings = {
    arrows: false,
    dots: false,
    fade: true,

    speed: 300,
    swipe: false
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_view">
        <div className="center_wrapper">
          <div className="slick_wrapper">
            <Slider
              {...settings}
              ref={sliderRef}
              afterChange={index => {
                dispatch(editCurrentIndex(index));
                contentsSliderRef.current.slickGoTo(index);
              }}
            >
              {bgImage?.multi_image?.map((data: any, idx: number) => {
                return (
                  <div key={idx} className="slider_image_box">
                    <img
                      src={!data || data === '' ? blackImageUrl : data}
                      alt=""
                    />
                  </div>
                );
              })}
            </Slider>
          </div>
          <div className="contents_wrapper">
            <Slider {...contentsSettings} ref={contentsSliderRef}>
              {text?.multi_title?.map((data: any, idx: number) => {
                return (
                  <div key={idx} className="contents_box">
                    <div className="title">
                      <p className="title_inner">
                        {changeEnter(text?.multi_title?.[idx])}
                      </p>
                    </div>
                    <div className="sub_title">
                      <div className="sub_title_inner">
                        {changeEnter(text?.multi_sub_title?.[idx])}
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
          <div className="bottom_wrapper">
            <button>{btnText?.multi_button?.[currentIndex]}</button>
            <div className="close_btn">{btnText?.sub_button}</div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SlideFullImage;
